<template>
  <cd-layout>
    <template #page-title>
      Authentication
    </template>

    <template #page-meta>
      <b-row class="no-gutters">
        <b-col cols="6" lg="3" class="up order-2 order-lg-1 text-left">
          <b-button variant="outline-secondary">
            <strong>
              <i>
                Clear Signature
              </i>
            </strong>
          </b-button>
        </b-col>

        <b-col cols="12" lg="6" class="order-1 order-lg-2">
          <span>
            Sign here
          </span>
        </b-col>

        <b-col cols="6" lg="3" class="up order-3">
          <b-button variant="primary" class="ml-auto">
            <strong>
              <i>
                Done Signing
              </i>
            </strong>
          </b-button>
        </b-col>
      </b-row>
    </template>

    <template #page-body>
      <div class="auth text-center">
        <div class="auth-top">
          <strong>
            <i>
              I, GLOBAL PAYMENT TEXT CARD Agree to pay 56.67 according to my
              card issuer agreement. <br />

              Credit card ending in 6781 - Authorization Code:
              <span class="d-block">117872</span>
            </i>
          </strong>
        </div>

        <div class="auth-mid">
          <div class="area">
            <span class="area-label">
              Signature Here
            </span>
          </div>
        </div>

        <div class="auth-bottom mt-auto">
          <b-row class="justify-content-lg-end">
            <b-col cols="8" lg="6">
              <b-button variant="dark" class="w-100">
                <strong>
                  <i>
                    SIGNUP FOR HAND PAYMENTS
                  </i>
                </strong>
              </b-button>
            </b-col>
            <b-col cols="4" lg="3">
              <b-button
                variant="outline-secondary"
                class="i"
                v-b-tooltip.hover
                title="Tooltip directive content"
              >
                <strong>
                  <i>
                    ?
                  </i>
                </strong>
              </b-button>
            </b-col>
          </b-row>
        </div>
      </div>
    </template>
  </cd-layout>
</template>
<script>
import CdLayout from '../layouts/CdLayout'

export default {
  name: 'Authentication',
  components: {
    CdLayout
  },
  data () {
    return {}
  },
  methods: {},
  computed: {}
}
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/Authentication.vue